// Mock data para CALYPSO EVENT GROUP

export const companyInfo = {
  name: "CALYPSO EVENT GROUP",
  tagline: "Creando Momentos Inolvidables",
  mission: "Brindar un servicio de alta calidad, transformando cada evento en una experiencia única y memorable, superando las expectativas de nuestros clientes con Creatividad, Profesionalismo y Atención al detalle.",
  location: {
    city: "Columbus, Ohio",
    area: "Área de servicio: Perímetro Highway 270",
    phone: "+1 (614) 597-4338",
    email: "infow@calypsoeventgroup.com"
  }
};

export const categories = [
  {
    id: 'bodas',
    name: 'Bodas',
    description: 'Bodas de ensueño diseñadas a tu medida',
    color: '#ff84e4',
    media: [
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/6g04b81s_2.png',
        title: 'Primer Baile Romántico'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/4vtv5w0f_3.png',
        title: 'Momento Especial'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/56zl0b19_5.png',
        title: 'Ambiente Festivo'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/spuc4zzy_6.png',
        title: 'Celebración Inolvidable'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/o2f4qtup_7.png',
        title: 'Baile y Diversión'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_0acefb1b-90a7-4f3c-9659-a089dac978af/artifacts/nung792f_IMG_1363~3.JPG',
        title: 'Setup Profesional'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/xejyj87l_View%20recent%20photos.png',
        title: 'Pista de Baile Llena'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_0acefb1b-90a7-4f3c-9659-a089dac978af/artifacts/i907osvl_8~3.png',
        title: 'Iluminación Verde Elegante'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/vp3hn63c_IMG_8282.jpeg',
        title: 'Ambiente Morado Sofisticado'
      }
    ]
  },
  {
    id: 'quinceaneras',
    name: 'Quinceañeras',
    description: 'Celebra tus 15 años con estilo y elegancia',
    color: '#1f47e6',
    media: [
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/48w0es9q_9.png',
        title: 'Quinceañera Elegante'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/cod00u5s_10.png',
        title: 'Ambiente Festivo'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/ptj2tds6_13.png',
        title: 'Celebración Especial'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/e5e4m76f_IMG_1629.JPG',
        title: 'Fiesta de Ensueño'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/s6b1pbe9_IMG_0344.jpeg',
        title: 'Momento Mágico'
      }
    ]
  },
  {
    id: 'celebraciones',
    name: 'Eventos',
    description: 'Eventos corporativos y celebraciones especiales',
    color: '#d987ff',
    media: [
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/pfwq4ywa_4.png',
        title: 'Ambiente Espectacular'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/epmpn051_11.png',
        title: 'Evento Corporativo'
      },
      {
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_event-showcase-52/artifacts/sas0ihsk_IMG_1662.JPG',
        title: 'Iluminación Profesional'
      }
    ]
  }
];

export const socialMedia = [
  {
    name: 'Facebook',
    icon: 'Facebook',
    url: 'https://www.facebook.com/CalypsoEG',
    color: '#1877f2'
  },
  {
    name: 'Instagram',
    icon: 'Instagram',
    url: 'https://www.instagram.com/calypsoeventgroup?igsh=MWh0OG42ZXJvZXA5eQ%3D%3D&utm_source=qr',
    color: '#E4405F'
  },
  {
    name: 'WhatsApp',
    icon: 'MessageCircle',
    url: 'https://wa.me/16145974338',
    color: '#25d366'
  },
  {
    name: 'TikTok',
    icon: 'Music',
    url: 'https://www.tiktok.com/@al3xzambrano?_r=1&_t=ZP-94RHqRnQOkx',
    color: '#000000'
  },
  {
    name: 'Email',
    icon: 'Mail',
    url: 'mailto:infow@calypsoeventgroup.com',
    color: '#ff84e4'
  },
  {
    name: 'Teléfono',
    icon: 'Phone',
    url: 'tel:+16145974338',
    color: '#1f47e6'
  }
];

export const getCategoriesByLanguage = (lang) => {
  const titles = {
    en: {
      weddings: 'Weddings',
      quinceaneras: 'Quinceañeras',
      events: 'Events',
      weddingsDesc: 'Dream weddings designed to your measure',
      quinceanerasDesc: 'Celebrate your 15 years with style and elegance',
      eventsDesc: 'Corporate events and special celebrations'
    },
    es: {
      weddings: 'Bodas',
      quinceaneras: 'Quinceañeras',
      events: 'Eventos',
      weddingsDesc: 'Bodas de ensueño diseñadas a tu medida',
      quinceanerasDesc: 'Celebra tus 15 años con estilo y elegancia',
      eventsDesc: 'Eventos corporativos y celebraciones especiales'
    }
  };

  const t = titles[lang] || titles.en;

  return [
    {
      id: 'bodas',
      name: t.weddings,
      description: t.weddingsDesc,
      color: '#ff84e4',
      media: categories[0].media
    },
    {
      id: 'quinceaneras',
      name: t.quinceaneras,
      description: t.quinceanerasDesc,
      color: '#1f47e6',
      media: categories[1].media
    },
    {
      id: 'celebraciones',
      name: t.events,
      description: t.eventsDesc,
      color: '#d987ff',
      media: categories[2].media
    }
  ];
};
